import Vue from "vue";
import { Loading, MessageBox } from "element-ui";
import { getMoguoCdnUrl } from "../../utils/assets";

class saasLoading {
  constructor() {}
  init(obj) {
    if (window.saasLoading) return;

    const closeBtn = document.createElement("img");
    closeBtn.src = getMoguoCdnUrl("/cdn/static/images/close-icon.png");
    closeBtn.style.cssText =
      "position:absolute;top:35px;right:30px;width:25px;cursor:pointer;-webkit-app-region: no-drag;";

    window.saasLoading = Loading.service({
      lock: true,
      text: "进入教室中",
      spinner: "el-icon-loading",
      background: "rgba(255,255,255,.6)",
      fullscreen: true,
      customClass: "saas-fullscreen-loading",
      ...obj,
    });

    // 加关闭按钮
    // setTimeout(() => {
    let eleLoading = document.querySelector(".saas-fullscreen-loading");
    if (!eleLoading) return;
    eleLoading.appendChild(closeBtn);
    // 监听关闭
    closeBtn.addEventListener("click", () => {
      if (window?.controller?.abort) {
        window?.controller.abort();
      }
      console.log(window.loadingTimer, "loading-click====");
      clearTimeout(window.loadingTimer);
      if (!window?.saasLoading) return;
      window.saasLoading.close();
      window.saasLoading = null;
    });
    // }, 0);

    // 超时处理
    window.loadingTimer = setTimeout(() => {
      console.log(window.loadingTimer, "setTimeout-loading-执行了====");
      if (window?.controller?.abort) {
        window?.controller.abort();
      }
      if (!window.saasLoading) return;
      window.saasLoading.close();
      window.saasLoading = null;
      MessageBox.confirm("哎呀呀，加载出错了，请重新尝试！", {
        center: true,
        showCancelButton: false,
        confirmButtonText: "确定",
        customClass: "saas-confirm-message",
        confirmButtonClass: "confirm-btn",
        closeOnClickModal: false,
      })
        .then(() => {})
        .catch(() => {});
    }, 60 * 1000);
    console.log(window.loadingTimer, "loading-init====");
  }

  // 正常关闭
  close() {
    console.log(window.loadingTimer, "loading-close====");
    clearTimeout(window.loadingTimer);
    if (!window.saasLoading) return;
    window.saasLoading.close();
    window.saasLoading = null;
  }
}

// Vue.prototype.$saasLoading = () => new saasLoading();
Vue.prototype.$saasLoadingShow = () => new saasLoading().init();
Vue.prototype.$saasLoadingClose = () => new saasLoading().close();
